import React from "react";
import styles from "./Card.scss";

export const Card = ({ children }) => {
    return (
        <div className={styles.card}>
            <div className={styles.wrapper}>{children}</div>
        </div>
    );
};
